<template>
  <div>
    <el-dialog :close-on-click-modal="false"
      title="添加菜品"
      :visible.sync="addFlow"
      :before-close="addProHandleClose"
      width="90rem"
      center
     
    >
      <div class="content">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
            <div class="Flex space names_flow">
                <div class="name">
                  <el-form-item label="名称：" prop="name">
                    <el-input v-model="ruleForm.name" placeholder="请输入" maxlength="15"></el-input>
                  </el-form-item>
                </div>
                <div class="price Flex">
                  <el-form-item label="价格：" prop="price">
                    <el-input v-model="ruleForm.price" maxlength="8" oninput="value=value.replace(/^\D*([0-9]\d*\.?\d{0,2})?.*$/,'$1')" placeholder="请输入"></el-input>
                  </el-form-item>
                  <span class="unit">元</span>
                </div>
            </div>
            <div class="Flex space flex_two">
              <el-form-item label="分类：" prop="classid">
                <el-select v-model="ruleForm.classid" placeholder="请选择">
                  <el-option
                      v-for="item in option"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                    </el-option>
                </el-select>
              </el-form-item>   
              <el-form-item label="顺序：" prop="sort">
                <el-input v-model="ruleForm.sort" placeholder="请输入" oninput ="value=value.replace(/[^0-9.]/g,'')"></el-input>
              </el-form-item>   
              <el-form-item label="单位：" prop="unit">
                <el-input v-model="ruleForm.unit" placeholder="请输入" maxlength="3"></el-input>
              </el-form-item>   
              <el-form-item label="状态：" prop="state">
                <el-select v-model="ruleForm.state" placeholder="请选择">
                    <el-option
                    v-for="item in optionType"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                  </el-select>
              </el-form-item>   
            </div>
            <el-form-item label="描述：" prop="info">
              <div class="mask_notes"> 
                <el-input type="textarea" maxlength="50" v-model="ruleForm.info" placeholder="--"></el-input>
              </div>
            </el-form-item>
            <div class="Flex flex_three">
              <el-form-item label="每日库存：" prop="daylimitnum">
                  <el-input placeholder="请输入" v-model="ruleForm.daylimitnum" oninput ="value=value.replace(/[^0-9.]/g,'')"></el-input>
              </el-form-item> 
              <span>注：0代表不限制库存</span>
            </div>
            <div class="Flex flex_three">
              <el-form-item label="单次限制：" prop="orderlimitnum">
                  <el-input placeholder="请输入" v-model="ruleForm.orderlimitnum" oninput ="value=value.replace(/[^0-9.]/g,'')"></el-input>
              </el-form-item> 
              <span>注：用户每次下单的限制数量，0代表不限制购买</span>
            </div>
            <el-form-item label="销售日期：">
              <el-date-picker
                v-model="ruleForm.consumebegindate"
                value-format="yyyy-MM-dd"
                type="date"
                @change="changDate(true)"
                placeholder="选择日期">
              </el-date-picker>
              <span style="margin:0 1rem;">至</span>
              <el-date-picker
                v-model="ruleForm.consumeenddate"
                value-format="yyyy-MM-dd"
                type="date"
                @change="changDate(false)"
                placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="时段设置：" >
              <div class="names_times"  v-for="(item,index) in arropen" :key="index">
                <el-time-picker
                  arrow-control
                  v-model="item.statrTime"
                  value-format="HH:mm">
                </el-time-picker>
                <span style="margin:0 1rem;">至</span>
                <el-time-picker
                    arrow-control
                    v-model="item.endTime"
                    value-format="HH:mm">
                </el-time-picker>
                 <img class="imgs_times" src="@/assets/addpro.png" alt="" v-if="index+1==arropen.length" @click="addSonpro">
                 <img  class="imgs_times" src="@/assets/jianpro.png" alt="" v-if="index>0" @click="reduce(index)">
              </div>
            </el-form-item>
            <el-form-item label="档口：" prop="stallid">
                <el-select v-model="ruleForm.stallid" placeholder="请选择">
                    <el-option
                      v-for="item in stallOption"
                      :key="item.id"
                      :label="item.stall"
                      :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>  
            <el-form-item label="上传图片：" prop="pic">
              <!-- <el-upload
                class="avatar-uploader"
                action="http://xwt.softykt.net/api/product/uploadInfoRemit"
                :show-file-list="false"    
                :on-success="attachUploadSuccess"
                :data="datas"  
                >
                <img v-if="ruleForm.pic" :src="ruleForm.pic" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload> -->
              <div class="flexs_upload">
                    <cutImageDialog :imgs="ruleForm.pic" @resurl="resurl"  v-if="flag" />
              </div>  
            </el-form-item>
        </el-form>
        <div class="contentBtns">
            <!-- <div>重置</div> -->
            <div @click="add('ruleForm',2)">确认保存，稍后授权</div>
            <div @click="add('ruleForm',1)">确认保存，前往授权</div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {ClassList,StallList,MenuAdd,MenuUpdate,Menudetail} from '@/request/scenic.js'
import { Message } from 'element-ui'
import cutImageDialog from '@/assets/place.vue'
    export default{
      data(){
        return{
          addFlow:false,
          rules:{
            name: [
              { required: true, message: '请输入名称', trigger: 'blur' },
            ],
            price: [
              { required: true, message: '请输入价格', trigger: 'blur' },
            ],
            classid:[{ required: true, message: '请选择分类', trigger: 'change'}],
            state:[{ required: true, message: '请选择状态', trigger: 'change'}],
            unit:[ { required: true, message: '请输入单位', trigger: 'blur' },],
            sort:[
              { required: true, message: '请输入顺序', trigger: 'blur' },
            ],
            info:[
              { required: true, message: '请输入描述', trigger: 'blur' },
            ],
            daylimitnum:[
              { required: true, message: '请输入每日库存', trigger: 'blur' },
            ],
            orderlimitnum:[
              { required: true, message: '请输入下单限制', trigger: 'blur' },
            ],
            pic:[{ required: true, message: '请上传图片', trigger: 'change'}],
            stallid:[{ required: true, message: '请选择结束时间', trigger: 'change'}]
          },
          ruleForm:{
            token:window.sessionStorage.getItem('Token'),
            classid:'',
            classname:'',
            name:'',
            unit:'',
            state:'',
            sort:'',
            price:'',
            info:'',
            daylimitnum:'0',
            orderlimitnum:'0',
            consumebegindate:'',
            consumeenddate:'',
            pic:'',
            businesstime:'',
            stallid:''
          },
          option:[
          ],
          datas:{
            token:window.sessionStorage.getItem('Token')
          },
          optionType:[
            {
              value:'0',
              label:'下架'
            },
            {
              value:'1',
              label:'上架'
            }
          ],
          stallOption:[],
          arropen:[
            {
              statrTime:'00:00',
              endTime:'23:59'
            }
          ],
          flag:false
        }
      },
      components:{
        cutImageDialog 
      },
      created(){
       
      },
      methods:{
        changDate(flag){
          if (flag) {
            if (this.ruleForm.consumeenddate) {
              if (this.getDate(this.ruleForm.consumebegindate) > this.getDate(this.ruleForm.consumeenddate)) {
                this.ruleForm.consumebegindate = null;
                Message.error("开始时间不能大于等于结束时间！");
              }
            }
          } else {
            if (this.ruleForm.consumebegindate) {
              if ( this.getDate(this.ruleForm.consumeenddate) <  this.getDate(this.ruleForm.consumebegindate) ) {
                this.ruleForm.consumeenddate = null;
                Message.error("结束时间不能小于开始时间！");
              }
            }
          }
        },
        getDate(m){
          var date = new Date(m);
          var time1 = date.getTime();
          return time1
        },
        resurl(row){
          this.ruleForm.pic = row
        },
        reduce(index){
          this.arropen.splice(index,1)
        },
        addSonpro(){
          this.arropen.push( {
              statrTime:'00:00',
              endTime:'23:59',
            })
        },
        attachUploadSuccess(response){
          this.ruleForm.pic = response.result
        },
        pxFn(row){
          if(row.id){
            // this.ruleForm = row
            // // this.ruleForm.stallid += ''
            
            // this.statrTime = row.businesstime.substring(0,5)
            // this.endTime = row.businesstime.substring(6,row.businesstime.length)
            let datas = {
              id:row.id,
              token:window.sessionStorage.getItem('Token')
            }
            Menudetail(datas).then(res=>{
              if(res.data.status=='ok'){
                this.ruleForm = res.data.result
                this.ruleForm.state += ''
                this.flag = true
                if(res.data.result.starttime.length>0){
                  this.arropen = []
                  for(let i=0;i<res.data.result.starttime.length;i++){
                    this.arropen.push({
                      statrTime:res.data.result.starttime[i],
                      endTime:res.data.result.stoptime[i]
                    })
                  }  
                }
              }
            })
          }
          let data = {
            page:1,
            page_size:999,
            token:window.sessionStorage.getItem('Token')
          }
          ClassList(data).then(res=>{
            if(res.data.status=='ok'){
              this.option = []
              res.data.result.data.map(item=>{
                if(item.state=='1'){
                  this.option.push(item)
                }
              })
              if(this.option.length==0){
                Message.error('请添加分类')
                this.$emit('close')
                return false
              }
            }
          })
          StallList(data).then(res=>{
            if(res.data.status=='ok'){
              this.stallOption = res.data.result.data
              if(this.stallOption.length==0){
                Message.error('请添加档口')
                this.$emit('close')
                return false
              }else{
                this.addFlow = true
              }
            }
          })
          this.flag = true
        },
        addProHandleClose(){
          this.flag = false
          this.addFlow = false
          this.$emit('close')
        },
        add(ruleForm,e){
          this.ruleForm.token= window.sessionStorage.getItem('Token')
          if(!this.ruleForm.classid){
            Message.error('请选择分类')
            return false
          }
          if(!this.ruleForm.consumebegindate||!this.ruleForm.consumeenddate){
            Message.error('请选择销售时间');
            return false
          }
          if(this.arropen[0].statrTime==''){
            Message.error('请选择时段设置');
            return false
          }
          if(this.arropen[0].endTime==''){
            Message.error('请选择时段设置');
            return false
          }
          this.option.map(item=>{
            if(item.id==this.ruleForm.classid){
              this.ruleForm.classname = item.name
            }
          })
          this.$refs.ruleForm.validate((valid)=>{
            if(valid){
              let starttime = []
              let stoptime = []
              for (const i of this.arropen) {
                starttime.push(i.statrTime)
                stoptime.push(i.endTime)
              }
              this.ruleForm.starttime = starttime
              this.ruleForm.stoptime = stoptime
              if(this.ruleForm.id){
                // this.ruleForm.businesstime = this.statrTime + ' 至 ' + this.endTime
                MenuUpdate(this.ruleForm).then(res=>{
                  if(res.data.status=='ok'){
                    this.addFlow = false
                    this.$emit('close',e)
                    Message.success('修改成功')
                  }else{
                    Message.error(res.data.msg)
                  }
                })
              }else{
                // this.ruleForm.businesstime = this.statrTime+' 至 '+this.endTime
                MenuAdd(this.ruleForm).then(res=>{
                  if(res.data.status=='ok'){
                    this.addFlow = false
                    this.$emit('close',e)
                    Message.success('添加成功')
                  }else{
                    Message.error(res.data.msg)
                  }
                })
              }
            }else{
              return false
            }
          })
          this.flag = false
        }
      }
    }
</script>

<style scoped lang="less">
::v-deep .el-dialog__body{
  padding: 2rem 0 !important;
  border-top: 1px solid #E5E5EA;
}
.content{
  padding: 0 2rem 2rem 2rem;
  box-sizing: border-box;
 
  .flex_two{
    ::v-deep .el-input{
      width: 30rem;
    }
    ::v-deep .el-select{
      width: 30rem;
    }
  }
  .flex_three{
    ::v-deep .el-input{
      width: 12rem;
    }
    span{
      margin: 0 0 2.2rem 1rem;
      color: #E74C3C;
      font-size: 1.4rem;
    }
  }
}
.Flex{
  display: flex;
  align-items: center;
  flex-wrap:wrap ;
}
.space{
  justify-content: space-between;
}
.unit{
  margin-bottom: 2.2rem;
  margin-left: 1rem;
  font-size:1.4rem;
  color: #666;
}
.mask_notes ::v-deep .el-textarea textarea{
    resize: none;
    height: 8rem;
}
::v-deep .el-upload {
    border-radius: 4px;
    border: 1px solid #E5E5EA;
    background: #FFF;
    width: 10rem;
    height: 7rem;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width:100%;
    height: 100%;
    line-height: 7rem;
    text-align: center;
  }
  .contentBtns{
    margin-top: 4rem;
    display: flex;
    align-items: center;
    justify-content: center;
    div{
      padding: 0 2rem;
      box-sizing: border-box;
      margin-right: 2rem;
      height: 4rem;
      border-radius: 4px;
      line-height: 4rem;
      text-align: center;
      color: #fff;
      font-size: 1.4rem;
      cursor: pointer;
        background: #246DEB;
    }
  }
  ::v-deep .el-dialog__wrapper{
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
::v-deep .el-upload {
    border-radius: 4px;
    border: 1px solid #E5E5EA;
    background: #FFF;
    width: 10rem;
    height: 7rem;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width:100%;
    height: 100%;
    line-height: 7rem;
    text-align: center;
  }
  .avatar {
    width:100%;
    height: 100%;
    display: block;
  }
  .imgs_times{
    margin-left: 2rem;
    cursor: pointer;
  }
  .names_times{
  &:nth-child(n+2){
    margin-top: 2rem;
  }
}
.names_flow{
  flex-direction: column;
  >div{
    width: 100% !important;
  }
}
</style>